var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CellDefaultProps } from './defaults';
var Cell = function (_a) {
    var component = _a.component, span = _a.span, hasBorder = _a.hasBorder, label = _a.label, content = _a.content, colon = _a.colon, className = _a.className, rest = __rest(_a, ["component", "span", "hasBorder", "label", "content", "colon", "className"]);
    var Component = component;
    if (hasBorder) {
        return (React.createElement(Component, __assign({ className: "item item-" + (label ? 'label' : 'content') + " " + className, colSpan: span }, rest),
            label || content,
            colon ? ':' : ''));
    }
    return (React.createElement(Component, __assign({ className: "item " + className, colSpan: span }, rest),
        label && (React.createElement("span", { className: "item-label" },
            label,
            colon ? ':' : '')),
        content && React.createElement("span", { className: "item-content" }, content)));
};
Cell.defaultProps = CellDefaultProps;
export default Cell;
